import { WarningFilled } from "@ant-design/icons";
import Paragraph from "antd/es/typography/Paragraph";
import Title from "antd/es/typography/Title";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Expired = ({ transactionId, canRetry }) => {
  const { t } = useTranslation("result");
  return (
    <div style={{ paddingLeft: 10, paddingRight: 10 }}>
      <Title>
        <WarningFilled style={{ color: "orange" }} /> {t("paymentExpiredTitle")}
      </Title>
      <Paragraph>{t("paymentExpiredDescription")}</Paragraph>
      {canRetry && (
        <Link to={`/transaction/${transactionId}/pay`}>
          {t("retryPayment")}
        </Link>
      )}
    </div>
  );
};

export default Expired;
